export enum SubscriptionActivationType {
  firstClassVisit = 'firstclassvisit',
  fixedDates = 'fixeddates'
};
